import { gql, useApolloClient, useLazyQuery } from "@apollo/client";

export const REPORT_DATA_QUERY = gql`
  query GetReportData(
    $reportName: String
    $reportVariables: Map_String_ObjectScalar
  ) {
    report(reportId: $reportName, reportParameters: $reportVariables)
  }
`;

export interface ReportDataQuery {
  report: string;
}

export const useGetReportData = () => {
  const [performQuery] = useLazyQuery<ReportDataQuery>(REPORT_DATA_QUERY, {
    fetchPolicy: "no-cache",
  });
  const getReportData = async (
    reportName: string,
    reportVariables: Record<string, unknown>
  ) => {
    return await performQuery({
      variables: {
        reportName,
        reportVariables,
      },
      context: {
        reportId: Date.now(),
      },
    });
  };

  return { getReportData };
};

export const useGetMultipleReportData = () => {
  const client = useApolloClient();
  const getReportData = async (
    reports: { reportName: string; reportVariables: Record<string, unknown> }[]
  ) => {
    if (reports.length === 0) {
      throw new Error("Velg minst én rapport.");
    }

    const declarations = reports.map(
      (_, index) =>
        `$reportName${index}: String, $reportVariables${index}: Map_String_ObjectScalar`
    );
    const fields = reports.map(
      (_, index) =>
        `report${index}: report(reportId: $reportName${index}, reportParameters: $reportVariables${index})`
    );
    const variables: Record<string, unknown> = {};
    reports.forEach((report, index) => {
      variables[`reportName${index}`] = report.reportName;
      variables[`reportVariables${index}`] = report.reportVariables;
    });

    const result = await client.query<Record<string, string | null>>({
      query: gql`
        query GetMultipleReportData(${declarations.join(", ")}) {
          ${fields.join("\n")}
        }
      `,
      variables,
      fetchPolicy: "no-cache",
    });

    return {
      ...result,
      data: {
        reports: reports.map((_, index) => result.data[`report${index}`]),
      },
    };
  };

  return { getReportData };
};
